export const STREAMING_ENDPOINT = `${process.env.REACT_APP_BACKEND_ENDPOINT}/stream`;
export const STATUS = {
    SUCCESS: 'Success',
    ERROR: 'Error'
};
export const ANALYTICS_STATUS = {
    ANSWERED: 'answered'
}
export const SSE_CHANNELS = {
    EMAIL_UPDATE: 'email_update',
    KNOWLEDGE_UPDATE: 'knowledge_update',
    TODO_UPDATE: 'todo_update',
    UPLOAD_UPDATE: 'upload_update',
    FILTER_TREE: 'filter_tree'
};
export const SSE_TASKS = {
    EXTRACT_PRODUCT_TABLE: 'extract_product_table',
    PROCESS_KNOWLEDGE: 'process_knowledge',
    EXECUTE_TODOS: 'execute_todos',
    ANALYSE_EMAILS: 'analyse_emails',
    SEND_EMAIL: 'send_email',
    ANALYSE_UPLOAD: 'analyse_upload',
};